import React from "react";
import PropTypes from "prop-types";
import { Header, Label, Segment } from "semantic-ui-react";
import { formatDate } from "../formatters";
import RunTimeline from "./RunTimeline";

const RUN_STATE_COLORS = {
  running: "blue",
  stuck: "red",
  succeeded: "green",
  failed: "red",
  cancelled: "grey",
};

const RunDetail = ({ detail }) => {
  const { run } = detail;
  return (
    <>
      <Segment className="automation-monitoring__run-summary">
        <Header as="h2">{run.runId}</Header>
        <Label color={RUN_STATE_COLORS[run.state] || "grey"}>{run.state}</Label>
        <dl>
          <div><dt>Workflow version</dt><dd>{run.workflowVersion}</dd></div>
          <div><dt>Started</dt><dd>{formatDate(run.startedAt)}</dd></div>
          <div><dt>Ended</dt><dd>{formatDate(run.endedAt)}</dd></div>
          <div><dt>Current stage</dt><dd>{run.currentStageCode || "-"}</dd></div>
          <div><dt>Current step</dt><dd>{run.currentStepCode || "-"}</dd></div>
        </dl>
      </Segment>
      <RunTimeline
        events={detail.events || []}
        incidents={detail.incidents || []}
        workflow={detail.workflow}
      />
    </>
  );
};

RunDetail.propTypes = {
  detail: PropTypes.shape({
    run: PropTypes.object.isRequired,
    events: PropTypes.arrayOf(PropTypes.object),
    incidents: PropTypes.arrayOf(PropTypes.object),
    workflow: PropTypes.object,
  }).isRequired,
};

export default RunDetail;
